module.exports = __webpack_public_path__ + "img/light-snow.35cd16c4.svg";